import { useState } from 'react'
import { Button, FormLabel, Modal } from 'react-bootstrap'
import { FaFilter } from 'react-icons/fa'
import { IconWrapper } from 'web_core/assets/IconWrapper'
import { CategorySelector } from 'web_core/assets/category'
import { Designed } from 'web_core/types'

type Props = {
  size?: 'sm' | 'lg'
  variant?: string
  categoryFilter?: {
    onSelectId: (categoryId: string) => void
    id: string | undefined
  }
}

export const SearchFilter = ({
  categoryFilter,
  ...otherProps
}: Designed<Props>) => {
  const [show, setShow] = useState(false)
  return (
    <>
      <Button
        onClick={() => setShow(true)}
        variant="link"
        {...otherProps}
        className="px-2"
      >
        <IconWrapper suffix="フィルター" className="d-none d-sm-flex fs-6">
          <FaFilter />
        </IconWrapper>
        <FaFilter className="d-sm-none fs-6" />
      </Button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>フィルターの設定</Modal.Header>
        <Modal.Body>
          {categoryFilter && (
            <>
              <FormLabel className="fs-7 fw-bold">カテゴリ</FormLabel>
              <CategorySelector
                size="sm"
                undefinedLabel="未設定"
                onChange={categoryFilter.onSelectId}
                value={categoryFilter.id}
              />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShow(false)}>決定</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
